import React, { createContext, useContext, useState, ReactNode, useCallback } from 'react';

// Lot promu depuis Ratio vers Chiffrage : chaque entrée deviendra un onglet (Block level=0)
export interface PromotedLot {
  id: string;          // id Ratio (préservé pour ordre/dédup)
  nom: string;
  categorie: string;
  budgetInitial: number; // € — calculé à partir du ratio €/unit × quantité saisie
}

export interface RatioPromotion {
  lots: PromotedLot[];
  surface: number;     // quantité saisie par l'utilisateur dans Ratio (dans l'unité active)
  unitLabel: string;   // ex. "m² SDP", "logements"
}

interface RatioPromotionContextValue {
  pendingPromotion: RatioPromotion | null;
  setPendingPromotion: (p: RatioPromotion | null) => void;
  consumePromotion: () => RatioPromotion | null;
}

const RatioPromotionContext = createContext<RatioPromotionContextValue | undefined>(undefined);

export const RatioPromotionProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [pendingPromotion, setPendingPromotion] = useState<RatioPromotion | null>(null);

  const consumePromotion = useCallback(() => {
    const p = pendingPromotion;
    setPendingPromotion(null);
    return p;
  }, [pendingPromotion]);

  return (
    <RatioPromotionContext.Provider value={{ pendingPromotion, setPendingPromotion, consumePromotion }}>
      {children}
    </RatioPromotionContext.Provider>
  );
};

export function useRatioPromotion(): RatioPromotionContextValue {
  const ctx = useContext(RatioPromotionContext);
  if (!ctx) throw new Error('useRatioPromotion must be used within RatioPromotionProvider');
  return ctx;
}
